const action = (name) => `ADV.RETIREMENT_INCOME_CHART.${name}`;

export const
    SET_EXPANDED = action("SET_EXPANDED"),
    SET_INDEX = action("SET_INDEX"),
    SET_SHOW_DETAILS = action("SET_SHOW_DETAILS"),
    setExpanded = (expanded, clientId) => ({
        type: SET_EXPANDED,
        clientId,
        expanded,
    }),
    setIndex = (index, clientId) => ({
        type: SET_INDEX,
        clientId,
        index,
    }),
    setShowDetails = (showDetails, clientId) => ({
        type: SET_SHOW_DETAILS,
        clientId,
        showDetails,
    });